import { VideoEmbed } from "@elyxeer/ui";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

/**
 * The editor's copy of the member app's player.
 *
 * Literally the same `VideoEmbed`, with no `onProgress` handler — which is the point:
 * an editor who pastes an id should see the actual video the member will get, not a
 * thumbnail this panel fetched some other way. A private, deleted or non-embeddable
 * video is the commonest thing to get wrong about a video article, and it is only
 * visible by playing it.
 *
 * Renders nothing until the id has the right shape. A half-typed id would otherwise
 * remount the player on every keystroke and paint a YouTube error each time.
 */
export function VideoPreview({
  youtubeId,
  title,
  valid,
}: {
  youtubeId: string;
  title: string;
  /** The id passes the eleven-character check; the form owns that rule. */
  valid: boolean;
}) {
  const { t } = useTranslation();

  if (!valid) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Typography variant="OV1" sx={{ color: "text.muted" }}>
        {t("editor.videoPreview")}
      </Typography>
      <VideoEmbed
        youtubeId={youtubeId}
        title={title || t("editor.videoPreview")}
        unavailableLabel={t("editor.videoUnavailable")}
        testId="editor.video-preview"
      />
    </Box>
  );
}
